<template>
    <ToolButton :Editor="Editor" KnownIcon="SaveDraft" @ToolClick="SaveDraft()"
         :Size="10">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    methods:{
        SaveDraft(){
            this.$emit("SaveDraft");
        }
    },
    props: ["Editor"]
});
</script>